export const formatDate = (dateString) => {
  const buildDate = new Date(dateString);

  // Format as MM/DD/YYYY without the time
  const formattedDate = buildDate
    .toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
    .replace(/\//g, '.'); // Replace '/' with '.'

  // Rearrange to YYYY.MM.DD
  const [month, day, year] = formattedDate.split('.');
  return `${year}.${month}.${day}`;
};

export default formatDate;